import {API_HOST} from "@/core/variables";
import axios from "axios";

class SubscriptionTransactionRepository {
    async find(
        workspaceName?: string,
        planName?: string,
        startDate?: string,
        endDate?: string,
        skip?: number,
        limit?: number
    ) {
        return axios.get(`${API_HOST}/v1/subscription-transaction`, {
            params: {
                workspaceName: workspaceName,
                planName: planName,
                startDate: startDate,
                endDate: endDate,
                skip: skip,
                limit: limit
            }
        })
    }

    async downloadCSV(
        workspaceName?: string,
        planName?: string,
        startDate?: string,
        endDate?: string,
    ) {
        return axios.get(`${API_HOST}/v1/subscription-transaction/export`, {
            params: {
                workspaceName: workspaceName,
                planName: planName,
                startDate: startDate,
                endDate: endDate
            }
        })
    }
}

const subscriptionTransactionRepository = new SubscriptionTransactionRepository();
export default subscriptionTransactionRepository;
